import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["validationState", "variant", "className", "children", "dataContentPiece"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx as f } from "react/jsx-runtime";
import n, { forwardRef as m } from "react";
import { c as _ } from "../../../clsx-OuTLNxxd.js";
const p = "Select-module_select__r1yFt",
  v = "Select-module_select-default__BVzJO",
  S = "Select-module_select-transparent__v3SQH",
  h = "Select-module_select-white__WKuAy",
  R = "Select-module_state-invalid__YwJE3",
  c = {
    select: p,
    selectDefault: v,
    selectTransparent: S,
    selectWhite: h,
    stateInvalid: R
  };
function w() {
  for (var _len = arguments.length, s = new Array(_len), _key = 0; _key < _len; _key++) {
    s[_key] = arguments[_key];
  }
  const t = n.useRef(null);
  return n.useEffect(() => {
    s.forEach(e => {
      e && (typeof e == "function" ? e(t.current) : e.current = t.current);
    });
  }, [s]), t;
}
const y = (s, t) => {
    var _a$current;
    const {
        validationState: e = void 0,
        variant: l = "default",
        className: r,
        children: o,
        dataContentPiece: i
      } = s,
      u = _objectWithoutProperties(s, _excluded),
      a = n.useRef(null),
      d = w(t, a);
    return /* @__PURE__ */f("select", _objectSpread(_objectSpread({
      ref: d
    }, u), {}, {
      "data-value": a === null || a === void 0 || (_a$current = a.current) === null || _a$current === void 0 ? void 0 : _a$current.value,
      "aria-invalid": e == "error",
      className: _(r, c.select, {
        [c.selectDefault]: l == "default",
        [c.selectTransparent]: l == "transparent",
        [c.selectWhite]: l == "white",
        [c.stateInvalid]: e == "error"
      }),
      "data-content-piece": i,
      children: o
    }));
  },
  E = /* @__PURE__ */m(y);
export { E as Select };